import React from 'react';
import { X, Sparkles, CheckCircle2 } from 'lucide-react';

const WhatsNewModal = ({ title, content, version, onClose }) => {
  if (!title) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden transform transition-all animate-in zoom-in-95 duration-300">
        {/* Header */}
        <div className="relative h-32 bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center overflow-hidden">
          <div className="absolute top-0 right-0 p-2">
            <button 
              onClick={onClose}
              className="text-white/80 hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          <div className="text-center text-white px-4">
            <div className="bg-white/20 p-3 rounded-full inline-block mb-2">
              <Sparkles className="w-8 h-8" />
            </div>
            <h2 className="text-2xl font-bold line-clamp-1 leading-tight">{title}</h2>
            {version && <p className="text-green-50 text-sm mt-1 opacity-90 font-medium">Version {version}</p>}
          </div>
          
          {/* Decorative circles */}
          <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-white/10 rounded-full" />
          <div className="absolute -top-12 -right-12 w-32 h-32 bg-white/10 rounded-full" />
        </div>

        {/* Content */}
        <div className="p-6 md:p-8">
          <div className="prose prose-sm max-w-none text-gray-600 mb-8">
            <h3 className="text-gray-900 font-semibold mb-4 text-lg">What's New!</h3>
            <div className="space-y-3 max-h-[40vh] overflow-y-auto pr-2 custom-scrollbar">
              {content ? (
                content.split('\n').filter(note => note.trim()).map((note, index) => (
                  <div key={index} className="flex gap-3">
                    <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" />
                    <p className="leading-relaxed">{note.replace(/^[*-]\s*/, '')}</p>
                  </div>
                ))
              ) : (
                <p className="text-gray-500 italic">No details provided for this announcement.</p>
              )}
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-green-200"
          >
            Got it, thanks!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewModal;
